import { Pie, PieConfig } from '@ant-design/charts'
import React, { useMemo } from 'react'

import { EarningSummary } from '@/model/analytics'
import { formatPercentage, formatPrice } from '@/utils/formatter'

import s from './revenue-distribution-chart.module.css'

export default function RevenueDistributionChart({
  data,
}: { data?: EarningSummary }) {
  const total = useMemo(() => (data?.total ?? 0), [data?.total])
  const pieData = useMemo(() => ([{
    type: 'Subscriptions',
    value: data?.subscription,
  }, {
    type: 'Posts',
    value: data?.post,
  }, {
    type: 'Tips',
    value: data?.tip,
  }]), [data?.post, data?.subscription, data?.tip])

  const config: PieConfig = useMemo(() => ({
    angleField: 'value',
    colorField: 'type',
    scale: {
      color: {
        type: 'ordinal',
        range: ['#E6A443', '#66D1AD', '#ED716D'],
      },
    },
    tooltip: {
      items: [(d) => ({
        name: d.type,
        value: formatPrice()(d.value),
      })],
    },
    insetLeft: 20,
    insetRight: 20,
    innerRadius: 0.6,
    legend: false,
    height: 180,
  }
  ), [])

  return (
    <div className={s.Chart}>
      <Pie data={pieData} {...config} />
      <div className={s.Legends}>
        <div className={s.LegendItem}>
          <div className={s.Marker} />
          <span>Subscriptions</span>
          <span>{formatPrice()(data?.subscription)}</span>
          <span>({formatPercentage()((data?.subscription ?? 0) / total)})</span>
        </div>
        <div className={s.LegendItem}>
          <div className={s.Marker} />
          <span>Posts</span>
          <span>{formatPrice()(data?.post)}</span>
          <span>({formatPercentage()((data?.post ?? 0) / total)})</span>
        </div>
        <div className={s.LegendItem}>
          <div className={s.Marker} />
          <span>Tips</span>
          <span>{formatPrice()(data?.tip)}</span>
          <span>({formatPercentage()((data?.tip ?? 0) / total)})</span>
        </div>
      </div>
    </div>
  )
}